// import packageJson from "../package.json";

export const IS_DEV = process.env.NODE_ENV === "development";

export const PROTOCOL_HTTP = IS_DEV ? "http" : "https";
export const PROTOCOL_WS = IS_DEV ? "ws" : "wss";

export const HOST = window.location.host;

// const major = packageJson.version.split(".")[0];
// export const API_VERSION = `v${major}`; // → "v1"
// export const API_PREFIX = `/api/${API_VERSION}`; // → "/api/v1"
export const API_VERSION = "api";